import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as ArrowRight } from "../../assets/icons/arrowleft.svg";
import { ReactComponent as Home } from "../../assets/icons/Home.svg";

const Breadcrumb = ({ crumbs, skipPath = false }) => {
  const location = useLocation();
  const pathSegments = location.pathname
    .split("/")
    .filter((segment) => segment !== "");
  const breadcrumbItems = skipPath ? skipPath : pathSegments.map((segment, index) => {
    const url = `/${pathSegments.slice(0, index + 1).join("/")}`;
    const label = segment;

    return {
      url,
      label,
    };
  });

  const handleClick = (callFunction) =>{
    callFunction()
  }

  return (
    <nav
      className={`${crumbs
        ? "w-fit bg-breadcrumb py-2"
        : "w-full max-w-7xl mx-auto bg-breadcrumbSearch py-3 px-2"
        } relative mb-5 sm:flex hidden  flex-wrap items-center justify-between rounded-lg  text-neutral-500 lg:flex-wrap lg:justify-start `}
      data-te-navbar-ref
    >
      <div className="flex w-full flex-wrap items-center justify-between px-3">
        <nav className="bg-grey-light w-full rounded-md" aria-label="breadcrumb">
          <ol className={` ${crumbs ? "" : "gap-3"} list-reset flex`}>
            {crumbs &&
              crumbs.map((crumb, index) => {
                return (
                  <li key={index} className="breadcrumb-item flex items-center">
                    <span className="px-3 rounded-xl items-center">
                      {crumb.label}
                    </span>
                    <span className="mx-2 text-neutral-500 ">
                      <ArrowRight className="rotate-180" />
                    </span>
                  </li>
                );
              })}
            {!crumbs && !skipPath && (
              <li className="breadcrumb-item align-items-center">
                {" "}
                <Link
                  to="/"
                  className="flex items-center text-primary capitalize font-semibold gap-2"
                >
                  <Home className="pl-1" /> Home
                  <span className="mx-2 text-neutral-500  ">
                    <ArrowRight className="rotate-180 fill-navActive" />
                  </span>
                </Link>
              </li>
            )}
            {!crumbs &&
              breadcrumbItems.map((item, index) => {
                return (
                  <li
                    key={index}
                    className="breadcrumb-item align-items-center"
                  >
                    {index !== breadcrumbItems.length - 1 ? (
                      <Link
                        to={item.url && item.url}
                        onClick={()=>item.click ? handleClick(item.click) : null}
                        className="flex items-center capitalize text-primary font-semibold gap-2"
                      >
                        {`${item.label === "search" ? "Search Result" : item.label === "create-company" ? "Create Company" : item.label
                          }`}
                        <span className="mx-2 text-neutral-500 ">
                          <ArrowRight className="rotate-180" />
                        </span>
                      </Link>
                    ) : (
                      <span className="text-secondary font-semibold">
                        {" "}
                        {`${item.label === "search" ? "Search Result" : item.label === "create-company" ? "Create Company" : item.label
                          }`}
                      </span>
                    )}
                  </li>
                );
              })}
          </ol>
        </nav>
      </div>
    </nav>
  );
};

export default Breadcrumb;
